import { ga } from 'js/analytics/adapters'
export const trackLogOut = () => {
  ga.track('Log out')
}
